module.exports = __webpack_public_path__ + "static/img/zhifubao.f8676068.png";